const ReportFormLayout = () => import(/* webpackChunkName: "report" */'@/components/reportForm/ReportFormLayout')
const IncomeSummary = () => import(/* webpackChunkName: "report" */'@/components/reportForm/IncomeSummary')
const IncomeModalType = () => import(/* webpackChunkName: "report" */'@/components/reportForm/IncomeModalType')
const IncomeModalCustomer = () => import(/* webpackChunkName: "report" */'@/components/reportForm/IncomeModalCustomer')
const OrderSplitList = () => import(/* webpackChunkName: "report" */'@/components/reportForm/OrderSplitList')
const OrderSplitDetail = () => import(/* webpackChunkName: "report" */'@/components/reportForm/OrderSplitDetail')
const OrderBossList = () => import(/* webpackChunkName: "report" */'@/components/reportForm/BossOrderList')
export default {
  path: 'report',
  component: ReportFormLayout,
  children: [
    // 财务管理
    {
      name: 'incomeSummary',
      path: 'incomeSummary',
      component: IncomeSummary,
      meta: {
        module: 'report',
      },
    },
    // 分类型收入概况
    {
      name: 'incomeModalType',
      path: 'incomeSummary/incomeModalType',
      component: IncomeModalType,
      meta: {
        module: 'report',
      },
    },
    // 分客户概况
    {
      name: 'incomeModalCustomer',
      path: 'incomeSummary/incomeModalCustomer',
      component: IncomeModalCustomer,
      meta: {
        module: 'report',
      },
    },
    // 订单列表
    {
      name: 'bossOrderList',
      path: 'orderSplitList/bossOrderList',
      component: OrderBossList,
      meta: {
        module: 'report',
      },
    },
    // 订单分账 - 列表
    {
      name: 'orderSplitList',
      path: 'orderSplitList',
      component: OrderSplitList,
      meta: {
        module: 'report',
      },
    },
    // 订单分账 - 详情
    {
      name: 'orderSplitDetail',
      path: 'orderSplitList/orderSplitDetail/:id',
      component: OrderSplitDetail,
      meta: {
        module: 'report',
      },
    },
    {
      path: '/',
      redirect: { name: 'incomeSummary' },
    },
  ],
}



// WEBPACK FOOTER //
// ./src/router/ReportForm.js